import { Editor, Transforms, Element } from 'slate';
import { ReactEditor } from 'slate-react';
import ELEMENTS from '~/components/organism/PluginsEditor/components/elements/elementsEnum';
import type { DeepLinkElement, DHEditor } from '../../../types';
import type { DeepLink_ConfigFragment } from '~/graphql/types';
import convertDeepLinkConfigMappingToMapping from '../../../utils/deepLinks/convertDeepLinkConfigMappingToMapping';
import generateIdForEntity from '~/util/generateIdForEntity';
import { NO_TYPE_ID_KEY } from '~/hooks/useDeepLinkConfigs/utils/generateDeepLinkKey';

export const insertDeeplink = ({
  editor,
  params,
  linkText,
}: {
  editor: DHEditor;
  params: DeepLink_ConfigFragment;
  linkText: string;
}) => {
  const { name, type, typeId, mapping } = params;
  const marks = Editor.marks(editor);

  const deepLinkElement: DeepLinkElement = {
    type: ELEMENTS.DEEP_LINK,
    deeplinkText: linkText,
    deeplinkConfigName: name,
    children: [{ text: '', ...marks }],
    mappingId: generateIdForEntity('DEEP_LINK'),
    deeplinkType: type,
    deeplinkTypeId: typeId || NO_TYPE_ID_KEY,
    mapping: convertDeepLinkConfigMappingToMapping(mapping),
  };

  Transforms.insertNodes(editor, deepLinkElement);
  ReactEditor.focus(editor);

  // Move cursor so that it does not focus on the inserted deep link
  Transforms.move(editor, {
    distance: 1,
    unit: 'offset',
  });
};

/** If you are editing the DeepLink */
export const updateDeepLink = ({
  editor,
  updatedFields,
}: {
  editor: DHEditor;
  updatedFields: Omit<DeepLinkElement, 'type'>;
}) => {
  // Find path of the node again to make sure it's the latest path of the node
  const [nodeEntry] = Editor.nodes(editor, {
    at: [],
    match: n =>
      Element.isElement(n) &&
      n.type === ELEMENTS.DEEP_LINK &&
      n.mappingId === updatedFields.mappingId,
  });

  Transforms.setNodes(
    editor,
    {
      type: ELEMENTS.DEEP_LINK,
      ...updatedFields,
    },
    { at: nodeEntry[1] },
  );

  ReactEditor.focus(editor);
};
